import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './SideBar-Styles.scss';
import homeIcon from '../../assets/homeIcon.svg';
import usuariosIcon from '../../assets/usuariosIcon.svg';
import produtosIcon from '../../assets/produtosIcon.svg';
import servicosIcon from '../../assets/servicosIcon.svg';
import vendasIcon from '../../assets/vendasIcon.svg';
import caixaIcon from '../../assets/caixaIcon.svg';
import comissoesIcon from '../../assets/comissoesIcon.svg';
import configuracoesIcon from '../../assets/configuracoesIcon.svg';
import cadeadoAbertoIcon from '../../assets/cadeado-aberto.svg';
import cadeadoFechadoIcon from '../../assets/cadeado-fechado.svg';

export default function SideBar() {
  const [locked, setLocked] = useState(true); // true = expandido (bloqueado), false = colapsado
  const toggleLock = () => setLocked(l => !l);

  const menuItems = [
    { path: '/', label: 'Início', icon: <img src={homeIcon} alt="Início" /> },
  { path: '/clientes', label: 'Clientes', icon: <img src={usuariosIcon} alt="Clientes" /> },
  { path: '/funcionarios', label: 'Funcionários', icon: <img src={usuariosIcon} alt="Funcionários" /> },
    { path: '/produtos', label: 'Produtos', icon: <img src={produtosIcon} alt="Produtos" /> },
  { path: '/servicos', label: 'Serviços', icon: <img src={servicosIcon} alt="Serviços" /> },
    { path: '/vendas', label: 'Vendas', icon: <img src={vendasIcon} alt="Vendas" /> },
    { path: '/caixa', label: 'Caixa', icon: <img src={caixaIcon} alt="Caixa" /> },
    { path: '/comissoes', label: 'Comissões', icon: <img src={comissoesIcon} alt="Comissões" /> },
  ];

  const bottomItem = { path: '/configuracoes', label: 'Configurações', icon: <img src={configuracoesIcon} alt="Configurações" /> };

  return (
    <div className="sidebar-layout">
      <nav className={`sidebar ${locked ? 'locked' : 'collapsed'}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">Salão De Beleza</h2>
          <button
            type="button"
            className="sidebar-toggle"
            onClick={toggleLock}
            aria-label={locked ? 'Desbloquear barra lateral' : 'Bloquear barra lateral'}
            title={locked ? 'Desbloquear' : 'Bloquear'}
          >
            <img
              src={locked ? cadeadoFechadoIcon : cadeadoAbertoIcon}
              alt={locked ? 'Bloqueado' : 'Desbloqueado'}
              className="sidebar-toggle-icon"
            />
          </button>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map(item => (
            <li key={item.path} className="sidebar-item">
              <NavLink
                to={item.path}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                end={item.path === '/'}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-label">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sidebar-bottom">
          <NavLink
            to={bottomItem.path}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <span className="sidebar-icon">{bottomItem.icon}</span>
            <span className="sidebar-label">{bottomItem.label}</span>
          </NavLink>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}